import classnames from 'classnames/bind'
import Link from 'next/link'
import moment from 'moment'
import { useTranslation } from 'next-i18next'

// Components
import Shell from '../Shell'
import { ArrowRightIcon, DocumentIcon } from '../Icons'
import { LEGAL_DOCS } from '../LegalLinks'

// Methods
import { legalDocPath } from '../../methods'

// Types
import type { HelpLegalItem } from '@/api/fetchHelpLegal'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

type Props = {
  /** 後台已發佈的文件；沒有的那份顯示內建名稱、沒有更新日期 */
  docs: HelpLegalItem[]
  countryCode: string
  countryQuery?: string
}

/** 條款與政策總覽（header「服務條款」） */
const LegalIndex = ({ docs, countryCode, countryQuery }: Props) => {
  const { t } = useTranslation()

  return (
    <Shell countryCode={countryCode} countryQuery={countryQuery} breadcrumbs={[]}>
      <div className={cx('help-card')}>
        <h1 className={cx('help-card__title')}>{t('Help_Center_Legal_Title')}</h1>
        <p className={cx('help-card__desc')}>{t('Help_Center_Legal_Desc')}</p>
        <ul className={cx('help-article-list')}>
          {LEGAL_DOCS.map((item) => {
            const doc = docs.find((d) => d.pageKey === item.key)
            return (
              <li key={item.key}>
                <Link className={cx('help-article-list__item')} href={legalDocPath(item.key, countryQuery)}>
                  <span className={cx('help-article-list__icon')}>
                    <DocumentIcon />
                  </span>
                  <span className={cx('help-article-list__text')}>
                    <span className={cx('help-article-list__title')}>{doc?.title || t(item.label)}</span>
                    {doc?.updatedAt && (
                      <span className={cx('help-article-list__summary')}>
                        {t('Help_Center_Updated_At', { date: moment(doc.updatedAt).format('YYYY/MM/DD') })}
                      </span>
                    )}
                  </span>
                  <span className={cx('help-article-list__arrow')}>
                    <ArrowRightIcon size={16} />
                  </span>
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </Shell>
  )
}

export default LegalIndex
